export const GET_ADMINS = 'admins/GET_ADMINS';
export const CREATE_ADMIN = 'admins/CREATE_ADMIN';
export const GET_SCHOOL_ADMINS = 'admins/GET_SCHOOL_ADMINS';
export const FINISH_IMPORT_ADMINS = 'admins/FINISH_IMPORT_ADMINS';
